import { CRUDModel } from '@/models/CRUD.model';

export class ReferenceModel extends CRUDModel {
  static modelName = 'appointmentSource';
  static tableName = 'appointments/source';
}
